import { IconArrowBack, IconClose } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import {
	StyledModalBackButton,
	StyledModalCloseButton,
	StyledModalHeader,
	StyledModalHeading,
	StyledModalHeadingIcon,
} from './styled-modal-header';

const { forwardRef } = React;

const propTypes = {
	title: PropTypes.string.isRequired,
	backCallback: PropTypes.func,
	closeCallback: PropTypes.func,
	hasBackButton: PropTypes.bool,
	hasDepth: PropTypes.bool,
	headerIcon: PropTypes.element,
	headingId: PropTypes.string,
	srLabelBackButton: PropTypes.string,
	srLabelCloseButton: PropTypes.string,
};

const defaultProps = {
	backCallback: () => {},
	closeCallback: () => {},
	hasBackButton: false,
	hasDepth: false,
	headerIcon: undefined,
	headingId: undefined,
	srLabelBackButton: undefined,
	srLabelCloseButton: undefined,
};

const ModalHeader = forwardRef(
	(
		{
			backCallback,
			closeCallback,
			hasBackButton,
			hasDepth,
			headerIcon,
			headingId,
			srLabelBackButton,
			srLabelCloseButton,
			title,
			...rest
		},
		ref,
	) => (
		<StyledModalHeader hasDepth={hasDepth} ref={ref} {...rest}>
			{hasBackButton && (
				<StyledModalBackButton
					callback={backCallback}
					icon={<IconArrowBack />}
					ref={ref}
					srLabel={`${srLabelBackButton} dialog`}
				/>
			)}
			{headerIcon && (
				<StyledModalHeadingIcon color="var(--color-brand-mid)" icon={headerIcon} responsiveSize="small" />
			)}
			<StyledModalHeading
				hasBackButton={hasBackButton}
				headerIcon={headerIcon}
				id={headingId || `fuse-modal-heading`}
				size="3"
				type="heading"
			>
				{title}
			</StyledModalHeading>
			<StyledModalCloseButton
				callback={closeCallback}
				icon={<IconClose />}
				srLabel={`${srLabelCloseButton} dialog`}
			/>
		</StyledModalHeader>
	),
);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;

export default ModalHeader;
